import React, { useState } from 'react';
import { map, head, get, find, isBoolean } from 'lodash';
import { button as Button } from 'modules/button';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
import { Icon } from 'modules/icon-bank';
import { BLANK_VALUE_SYMBOL } from 'constants/common';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { setDrugPreference as SetDrugPreference } from 'ui/views/widgets/setDrugPreference';
 *
 * // render
 * <SetDrugPreference propName='propValue'/>
 */
export const setDrugPreference = ( props ) => {

	// field
	const field = head( props.fields );

	// field value
	const fieldValue = props.values[ field.name ];

	// get drug prefernce option
	const preferenceOptions = get( props.values, 'options.drugPreference', [] );

	// sleected drug
	const drugPreference = find( preferenceOptions, { value: get( props, 'values.drugPreference' ) } );

	// get displayValue
	const placeholderData = {
		drugPreference: drugPreference ? getLabel( drugPreference.title ): BLANK_VALUE_SYMBOL
	};

	// get options
	const options = get( props.values, `options.${field.options}`, [] );
	
	// selected tab index
	const [ value, switchValues ] = useState( fieldValue );

    return (
        <div className='ui-set-drug-preference'>
			<div className='ui-set-drug-preference__header'>

				{/* title for the modal */}
				<div className='ui-set-drug-preference__header__title'>
					{ getLabel( field.title ) }
				</div>

				{/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

			</div>

			<div className='ui-set-drug-preference__body'>

				{/* title for the drug preference */}
				<div className='ui-set-drug-preference__body__title'>
					{ getLabel( field.placeholder, placeholderData ) }
				</div>


				<div className='ui-set-drug-preference__body__options'>
					{ map( options, option => {
						return (
							<div key={ option.name } className='ui-set-drug-preference__body__options__option' onClick={ () => switchValues( option.value ) }>
								<RadioBox
									key={ option.name }
									name={ option.name }
									className='field-value-radio__item__checkbox'
									value={ option.value }
									selected={ value === option.value }
								/>
								
								<div className='ui-set-drug-preference__body__options__option__title'>
									{ getLabel( option.title ) }
								</div>
							</div>
						);
					} ) }
				</div>

				{/* button actions */}
				<div className='ui-set-drug-preference__body__actions'>
					{ map( props.actions, action => {
						return (
							<Button
								key={ action.name }
								{ ...action }
								outline={ 'cancel' === action.name ? true: false }
								size='medium'
								className='ui-set-drug-preference__body__actions__action'
								onClick={ () => 'cancel' !== action.name ? props.onSumbitClick( value ) : props.onCancelClick() }
								disabled={ 'submit' === action.name && ! isBoolean( value ) }
							/>
						);
					} ) }
				</div>
			</div>
           
        </div>
    );
};

// set display name
setDrugPreference.displayName = 'setDrugPreference';

// set default props
setDrugPreference.defaultProps = {};

// prop types
setDrugPreference.propTypes = {};
